var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#785353"
    },
    cx: 158.255,
    cy: 79.127,
    rx: 55.855,
    ry: 46.545
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E4848"
    },
    d: "M193.164,114.036c-30.848,0-55.855-20.84-55.855-46.545c0-13.874,7.324-26.295,18.881-34.822 c-29.883,0.912-53.79,21.333-53.79,46.458c0,25.706,25.007,46.545,55.855,46.545c14.199,0,27.12-4.451,36.973-11.724 C194.538,113.97,193.861,114.036,193.164,114.036z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#6E4848"
    },
    cx: 158.255,
    cy: 195.491,
    rx: 130.327,
    ry: 125.673
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#643C3E"
    },
    d: "M102.4,195.491c0-56.922,39.27-104.941,93.091-120.399c-11.806-3.391-24.287-5.274-37.236-5.274 c-71.978,0-130.327,56.265-130.327,125.673c0,69.406,58.349,125.673,130.327,125.673c12.949,0,25.43-1.883,37.236-5.274 C141.67,300.432,102.4,252.411,102.4,195.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3FF"
    },
    d: "M392.078,6.109c-43.234,7.165-77.654,42.605-83.814,85.994 c-5.553,39.113,11.095,74.622,39.074,96.116c-7.851,14.351-16.677,25.213-22.867,31.943c-2.43,2.643-0.049,6.856,3.47,6.145 c12.417-2.509,32.901-8.365,50.961-21.548c13.588,4.266,28.386,5.797,43.767,3.877c44.417-5.545,80.98-40.595,87.997-84.803 C521.759,53.936,462.05-5.487,392.078,6.109z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#87DCFF"
    },
    cx: 409.6,
    cy: 107.055,
    r: 83.782
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959CB5"
    },
    d: "M83.782,293.236H65.164c-10.283,0-18.618-8.335-18.618-18.618V256 c0-10.283,8.335-18.618,18.618-18.618h18.618V293.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959CB5"
    },
    d: "M232.727,237.382h18.618c10.283,0,18.618,8.335,18.618,18.618v18.618 c0,10.283-8.335,18.618-18.618,18.618h-18.618V237.382z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M299.323,407.094l-83.066-34.611c-6.938-2.89-11.457-9.67-11.457-17.187v-34.132h-93.091v34.133 c0,7.516-4.52,14.295-11.457,17.187l-83.066,34.611C6.779,411.429,0,421.598,0,432.873v55.855c0,10.282,8.336,18.618,18.618,18.618 h279.273c10.282,0,18.618-8.336,18.618-18.618v-55.855C316.509,421.598,309.73,411.429,299.323,407.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M111.709,321.164v34.133c0,2.882-0.838,5.567-2.049,8.054l16.948,9.416 c9.656,5.364,20.6,8.2,31.646,8.2c11.048,0,21.989-2.836,31.646-8.2l16.947-9.415c-1.211-2.488-2.049-5.171-2.049-8.054v-34.134 H111.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3FF"
    },
    d: "M316.509,488.727v-55.855c0-11.274-6.779-21.444-17.186-25.779l-67.87-28.279 c-36.807,53.962-73.199,54.058-73.199,54.058s-36.392-0.095-73.199-54.058l-67.87,28.279C6.779,411.429,0,421.598,0,432.873v55.855 c0,10.282,8.336,18.618,18.618,18.618h279.273C308.173,507.345,316.509,499.009,316.509,488.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C087"
    },
    d: "M201.593,174.495c-47.061,30.946-103.572,34.894-126.266,35.127 c-5.459,0.056-9.72,4.714-9.225,10.152l6.589,72.468c1.116,12.271,8.229,23.195,19,29.178l48.482,26.934 c11.247,6.248,24.92,6.248,36.167,0l48.482-26.934c10.771-5.983,17.884-16.908,19-29.178l7.043-77.475 c0.292-3.216-1.078-6.358-3.674-8.28c-6.719-4.975-20.52-15.91-33.432-30.6C210.679,172.386,205.488,171.935,201.593,174.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M119.318,269.431l-4.513-63.184c-16.612,2.61-30.647,3.272-39.509,3.368 c-5.453,0.058-9.688,4.719-9.194,10.149l6.589,72.476c1.116,12.272,8.229,23.196,19.001,29.181l48.481,26.934 c4.995,2.775,10.473,4.245,16.001,4.556c-7.204-9.027-12.99-17.221-17.62-24.444C127.215,310.775,120.815,290.389,119.318,269.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M409.645,63.418c-5.146,0-9.354-4.168-9.354-9.309s4.118-9.309,9.264-9.309h0.091 c5.146,0,9.309,4.168,9.309,9.309S414.791,63.418,409.645,63.418z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#643C3E"
    },
    d: "M139.646,256c-3.464,0-6.791-1.936-8.391-5.263c-0.946-1.964-4.554-4.046-9.382-4.046 s-8.436,2.082-9.382,4.046c-2.227,4.631-7.754,6.582-12.428,4.34c-4.628-2.237-6.572-7.8-4.337-12.432 c4.266-8.849,14.529-14.572,26.147-14.572s21.882,5.723,26.146,14.572c2.237,4.631,0.291,10.196-4.337,12.432 C142.373,255.704,141,256,139.646,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#643C3E"
    },
    d: "M212.409,256c-3.464,0-6.791-1.936-8.391-5.263c-0.946-1.964-4.554-4.046-9.382-4.046 c-4.828,0-8.436,2.082-9.382,4.046c-2.218,4.631-7.764,6.582-12.428,4.34c-4.628-2.237-6.572-7.8-4.337-12.432 c4.264-8.849,14.527-14.572,26.146-14.572s21.882,5.723,26.146,14.572c2.237,4.631,0.291,10.196-4.337,12.432 C215.137,255.704,213.763,256,212.409,256z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M418.909,144.291V97.745c5.146,0,9.309-4.168,9.309-9.309s-4.163-9.309-9.309-9.309h-18.618 c-5.146,0-9.309,4.168-9.309,9.309s4.163,9.309,9.309,9.309v46.545c-5.146,0-9.309,4.168-9.309,9.309 c0,5.141,4.163,9.309,9.309,9.309h18.618c5.146,0,9.309-4.168,9.309-9.309C428.218,148.459,424.055,144.291,418.909,144.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F8499"
    },
    d: "M244.61,283.927c-8.195,5.655-32.943,18.618-86.356,18.618c-5.146,0-9.309,4.168-9.309,9.309 c0,5.141,4.163,9.309,9.309,9.309c76.082,0,100.618-24.372,103.163-27.15c2.6-2.84,2.851-10.086-6.458-10.086H244.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M174.527,320.727c1.449-2.648,2.346-5.641,2.346-8.873c0-3.585-1.062-6.902-2.817-9.742 c-4.983,0.262-10.198,0.433-15.801,0.433c-5.146,0-9.309,4.168-9.309,9.309c0,5.141,4.163,9.309,9.309,9.309 C164.001,321.164,169.357,320.986,174.527,320.727z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M248.328,385.845l-16.874-7.031c-36.808,53.962-73.2,54.058-73.2,54.058 s-36.392-0.095-73.199-54.058l-16.874,7.031c28.444,42.453,56.895,57.453,74.122,62.748c3.903,1.2,6.641,4.695,6.641,8.778v22.046 c0,5.141,4.168,9.309,9.309,9.309c5.141,0,9.309-4.168,9.309-9.309v-22.037c0-4.083,2.74-7.58,6.644-8.78 C191.4,443.318,219.866,428.326,248.328,385.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M48.667,445.901L7.494,413.876C2.786,418.944,0,425.673,0,432.873v55.855 c0,10.282,8.336,18.618,18.618,18.618h37.236v-46.749C55.855,454.851,53.201,449.428,48.667,445.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M267.842,445.901l41.173-32.024c4.708,5.068,7.494,11.797,7.494,18.996v55.855 c0,10.282-8.336,18.618-18.618,18.618h-37.236v-46.749C260.655,454.851,263.308,449.428,267.842,445.901z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/worker.5e28208c0c2e273a16cea667bdba6850.svg";
export { ForwardRef as ReactComponent };